import { ModalForm } from './ModalForm';
import { Button } from '@/component/Form/Button';
import { Input } from '@/component/Form/Input';
import { Dropdown } from '@/component/Dropdown';

export const ModalFormAdress = ({
  onCloseModal,
  onSetStep,
  loading,
  isAddressInvalid,
  onAddressChange,
  address,
  addresses,
  onOpenDropdown,
  onAddressBlur,
  onResetAddress,
  onSelectAddress,
  setDisplayedAddress = null,
  nextStep,
  nextButtonText,
  nextButtonIcon,
  autoFocus = false,
}) => {
  return (
    <ModalForm
      onClose={onCloseModal}
      buttons={
        <>
          <Button theme="text" size="md" onClick={onCloseModal}>
            {'form.home-owner.modal-button-close'}
          </Button>
          <Button
            onClick={() => onSetStep(nextStep)}
            icon={nextButtonIcon}
            loading={loading}
            size="md"
          >
            {nextButtonText}
          </Button>
        </>
      }
    >
      <Input
        icon="icon-search"
        label="search-location"
        placeholder="form.input.address.placeholder"
        error={isAddressInvalid}
        onChange={onAddressChange}
        value={address}
        onClick={onOpenDropdown}
        onBlur={onAddressBlur}
        onReset={(e) => {
          onResetAddress(e);
          if (setDisplayedAddress) setDisplayedAddress('');
        }}
        disabled={loading}
        theme="filled"
        size="lg"
        autoFocus={autoFocus}
      />
      <div className="relative overflow-x-hidden overflow-y-auto flex flex-1 mb-4 mt-5 min-h-20">
        <Dropdown
          className="absolute top-0 left-0"
          value={address}
          items={addresses.map((addr) => ({ value: addr }))}
          loading={loading}
          isEmpty={addresses.length === 0}
          onSelect={(item) => {
            onSelectAddress(item.value);
            onSetStep(nextStep);
            if (setDisplayedAddress) setDisplayedAddress(item.value);
          }}
          disabled={loading}
        />
      </div>
    </ModalForm>
  );
};
